import { Sparkles, Trash2 } from 'lucide-react';

import { cn } from '@/lib/cn';

interface Props {
  startedAt: string;
  onResume: () => void;
  onDiscard: () => void;
}

export function DraftResumePrompt({ startedAt, onResume, onDiscard }: Props) {
  const when = formatRelativeDate(startedAt);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bg/80 px-4 backdrop-blur">
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-2xl bg-bg-secondary p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand/15">
            <Sparkles aria-hidden className="h-5 w-5 text-brand" />
          </span>
          <div className="flex flex-col gap-1">
            <h2 className="text-base font-bold text-fg">Resume your draft?</h2>
            <p className="text-xs text-fg-muted">
              You started an Avatar Editor session {when}. Pick up where you left off, or start fresh.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={onResume}
            className={cn(
              'flex items-center justify-center gap-2 rounded-xl bg-brand py-3 text-sm font-semibold text-brand-fg',
              'transition-opacity active:opacity-80',
            )}
          >
            Resume draft
          </button>
          <button
            type="button"
            onClick={onDiscard}
            className={cn(
              'flex items-center justify-center gap-2 rounded-xl bg-bg-tertiary py-3 text-sm font-semibold text-fg-muted',
              'transition-opacity active:opacity-80',
            )}
          >
            <Trash2 aria-hidden className="h-4 w-4" />
            Discard and start over
          </button>
        </div>
      </div>
    </div>
  );
}

function formatRelativeDate(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const minutes = Math.round((now - then) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return `${days}d ago`;
}
